import React, { useState } from 'react';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import style from "./Contactus.module.css";
import homepagestyle from "../HomePage/WhoWeAre.module.css"

const ContactUs = () => {
    // State for each input
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [consent, setConsent] = useState(false);

    const data = [
        {
            place: "India",
            image: "/NewPages/Homepage/locationIndia.svg",
            address: "No. 134A/140 Ground Floor,Balaji Arcade, Arcot Road, Virugambakkam,  Chennai – 600 092",
            mail: "murali@transforma.in",
            phone: "+91 9884006293"
        },
        {
            place: "USA",
            image: "/NewPages/Homepage/locationUsa.svg",
            address: "Transforma Inc.2015 Lincoln HWY,Suite # 210, Edison, NJ 08817,USA.",
            mail: "balaji.tv@transforma.in",
            phone: "+1 (609) 819-6802"
        }, {
            place: "GERMANY",
            image: "/NewPages/Homepage/locationGermany.svg",
            address: "Linus-IT GmbHWilhelm-Schrohe-Straße 7255128 Mainz, Germany",
            mail: "sunil.shah@linus-it.com",
            phone: "+49 151 52534628"
        }
    ]
    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!consent) {
            alert("Please accept the terms before submitting.");
            return;
        }

        // Collect form data
        const formData = {
            name,
            email,
            phone,
            message,
            consent
        };

        console.log("Form Data Submitted:", formData);
        // Here you can call an API to submit the data

        // Clear form after submit
        setName('');
        setEmail('');
        setPhone('');
        setMessage('');
        setConsent(false);
    }

    const Cards = () => {
        return (
            <div className={style.ContactCardsDetailsContainer} >
                {data.map((item, index) => (
                    <div key={index} className={style.ContactCardsDetails}>
                        <div className={style.contactdivider}>
                            <img src={process.env.PUBLIC_URL + item.image} alt="" />
                            <h1 className={style.countryHeading}>{item.place}</h1>
                        </div>
                        <div>
                            <p className={style.contactaddress}>{item.address}</p>
                        </div>
                        <div className={style.contactemails}>
                            <div className={`${style.contactdivider} ${style.contactemail}`}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.3333 5.8335L10.8408 10.606C10.5865 10.7537 10.2977 10.8315 10.0037 10.8315C9.70968 10.8315 9.42088 10.7537 9.16663 10.606L1.66663 5.8335" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16.6666 3.3335H3.33329C2.41282 3.3335 1.66663 4.07969 1.66663 5.00016V15.0002C1.66663 15.9206 2.41282 16.6668 3.33329 16.6668H16.6666C17.5871 16.6668 18.3333 15.9206 18.3333 15.0002V5.00016C18.3333 4.07969 17.5871 3.3335 16.6666 3.3335Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <p>{item.mail}</p>
                            </div>
                            <div className={`${style.contactdivider} ${style.contactemail}`}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.3333 5.8335L10.8408 10.606C10.5865 10.7537 10.2977 10.8315 10.0037 10.8315C9.70968 10.8315 9.42088 10.7537 9.16663 10.606L1.66663 5.8335" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16.6666 3.3335H3.33329C2.41282 3.3335 1.66663 4.07969 1.66663 5.00016V15.0002C1.66663 15.9206 2.41282 16.6668 3.33329 16.6668H16.6666C17.5871 16.6668 18.3333 15.9206 18.3333 15.0002V5.00016C18.3333 4.07969 17.5871 3.3335 16.6666 3.3335Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>{item.phone}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    return (
        <div className={style.pageWrapper}>
            <Navbar />
            <div className={style.contactusFontContainer}>


                <div id='contactus' className={style.contactusContainer}>
                    <h1>Let us know what you need help with</h1>
                    <div className={style.personalInformation}>
                        <p className={style.sectionTitle}>Personal Information</p>
                        <form className={style.contactForm} onSubmit={handleSubmit}>
                            <div className={style.formGrid}>
                                <div className={style.formGroup}>
                                    <label htmlFor="name">Your Name<span>*</span></label>
                                    <input
                                        type="text"
                                        id="name"
                                        placeholder="Enter your name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                                <div className={style.formGroup}>
                                    <label htmlFor="email">Email Address<span>*</span></label>
                                    <input
                                        type="email"
                                        id="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className={style.formGroup}>
                                    <label htmlFor="phone">Phone Number<span>*</span></label>
                                    <input
                                        type="text"
                                        id="phone"
                                        placeholder="Enter your phone number"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </div>
                                <div className={style.formGroupFull}>
                                    <label htmlFor="message">Message<span>*</span></label>
                                    <input
                                        type="text"
                                        id="message"
                                        placeholder="Write your message"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                    />
                                </div>

                            </div>

                            <div className={style.termsContainer}>
                                <div>
                                    <input
                                        type="checkbox"
                                        id="consent"
                                        checked={consent}
                                        onChange={(e) => setConsent(e.target.checked)}
                                    />
                                    <label htmlFor="consent" className={style.termsText}>
                                        By clicking the checkbox, you agree to our Form Terms and consent to the use of your data as outlined in our Privacy Policy.
                                    </label>
                                </div>
                                <button type="submit" className={style.submitBtn}>Send Message</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className={style.contactusInformationContainer}>
                    <div className={style.titleinformation}>
                        <p className={style.contactheading}>{`{ our offices }`}</p>
                        <h1 className={style.contactInformation}>Our global office locations</h1>
                        <p className={style.contactDescription}>Strategically located offices to support your business wherever you are.</p>
                    </div>
                    <div>
                        <Cards />
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default ContactUs;


